<script setup lang="ts">
import type { InputOption } from '../types'

type ModelValue = string | null
type OptionItem = InputOption<ModelValue>

export interface Props {
  id: string
  options: OptionItem[]
  placeholder?: string
  disabled?: boolean
  required?: boolean
  acceptCustomValue?: boolean
  spreadUp?: boolean
  removeBorder?: boolean
  fullWidth?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  options: () => [],
  placeholder: undefined,
  disabled: false,
  required: false,
  isSingleValue: false,
  acceptCustomValue: false,
  fullWidth: false,
})

const modelValue = defineModel<ModelValue>()
</script>

<template>
  <YscInputGroup
    :for="props.id"
    :required="required"
    :disabled="disabled"
  >
    <template
      v-if="$slots.default"
      #default
    >
      <slot />
    </template>
    <template #inputBlock>
      <YscCombobox
        v-model="modelValue"
        :input-id="id"
        :required="required"
        :disabled="disabled"
        :options="options"
        :full-width="fullWidth"
        :accept-custom-value="acceptCustomValue"
      />
    </template>
    <template
      v-if="$slots.description"
      #description
    >
      <slot name="description" />
    </template>

    <template
      v-if="$slots.error"
      #error
    >
      <slot name="error" />
    </template>
  </YscInputGroup>
</template>
